// Activity Emojis Library
// Contains 76 emojis representing various activities, sports, entertainment, and celebrations

export const activityEmojis = [
  // Sports
  '⚽', '🏀', '🏈', '⚾', '🥎', '🎾', '🏐', '🏉', '🎱', '🏓', '🏸', '🏒', '🏑', '🥍', '🏏', '🥅', '⛳', '🏹', '🎣', '🤿', '🥊', '🥋', '🛹', '⛸️', '⛷️', '🏂', '🪂', '🏋️', '🤼', '🤸', '🤺', '⛹️', '🤾', '🏌️', '🏇', '🏄', '🏊', '🚣', '🧗', '🚴', '🛼',
  
  // Entertainment & Arts
  '🎪', '🤹', '🎭', '🩰', '🎨', '🎬', '🎤', '🎧', '🎵', '🥁', '🎸', '🎷', '🎹', '🎻', '🪩', '🍽️', '🧋', '🍜', '🥟', '🥂', '🧀', '🥯', '🍚', '🍷', '👨‍🍳', '✈️', '🏔️', '🏝️', '🏕️', '🌉', '🌁', '🚋', '⛵', '🌊', '🦭', '🦮', '🐈', '🦄', '🌷', '👽', '😶‍🌫️', '✨', '🧳',
  // Games & Cards
  '🎲', '♠️', '♥️', '🎯', '🎳', '🎮', '🧩', '🎰', '🧶', '☕',

  // Religion & Spirituality
  '🛐','🧘','⚛️', '🕉️', '✡️', '☸️', '☯️', '✝️', '☦️', '☪️', '☮️', '🕎', '🔯', '🪯',

];

// Utility functions
export const getRandomActivityEmojis = (count = 10) => {
  const shuffled = [...activityEmojis].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
};

export const shuffleActivityEmojis = () => {
  return [...activityEmojis].sort(() => Math.random() - 0.5);
};

export const getActivityEmojisByCategory = () => {
  return {
    sports: [
      '⚽', '🏀', '🏈', '⚾', '🥎', '🎾', '🏐', '🏉', '🎱', '🏓', '🏸', '🏒', '🏑', '🥍', '🏏', '🥅', '⛳', '🏹', '🎣', '🤿', '🥊', '🥋', '🎽', '🛹', '🛷', '⛸️', '🥌', '🎿', '⛷️', '🏂', '🪂', '🏋️', '🤼', '🤸', '🤺', '⛹️', '🤾', '🏌️', '🏇', '🧘', '🏄', '🏊', '🤽', '🚣', '🧗', '🚵', '🚴'
    ],
    entertainment: [
      '🎪', '🤹', '🎭', '🩰', '🎨', '🎬', '🎤', '🎧', '🎼', '🎵', '🎶', '🥁', '🎸', '🎺', '🎷', '🎹', '🎻'
    ],
    games: [
      '🎲', '♠️', '♥️', '🎯', '🎳', '🎮', '🧩'
    ],
    celebrations: [
      '🎊', '🎉', '🎈', '🎁', '🎀'
    ]
  };
};

export default activityEmojis;
